<button
  [type]="type()"
  [disabled]="disabled()"
  [class]="classes()"
  [attr.aria-label]="label()"
  [attr.title]="label()"
  [attr.aria-haspopup]="haspopup()"
  [attr.aria-expanded]="expanded()"
  (click)="handleClick($event)"
>
  <esn-icon [name]="icon()" [size]="16" />
</button>
